var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-tooltip',{attrs:{"top":""},scopedSlots:_vm._u([{key:"activator",fn:function({ on, attrs }){return [_c('v-btn',_vm._g(_vm._b({staticClass:"border btn-redirect",class:{
        'border-nitro': !_vm.cycle.is_current && _vm.cycle.started,
        'white--text border-white' : _vm.cycle.is_current ,
        'nitro--text' : !_vm.cycle.is_current,
      },attrs:{"outlined":"","disabled":!_vm.cycle.started,"small":""},on:{"click":_vm.onClick}},'v-btn',attrs,false),on),[_c('v-icon',{staticStyle:{"font-size":"1.5em"}},[_vm._v("\n        fa fa-arrow-right\n      ")])],1)]}}])},[_vm._v("\n  Ir para o "+_vm._s(_vm.cycle.cycle_name)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }